export default "__VITE_ASSET__edf0957e__"